import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { UserContext } from '../common/UserContext';
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";

function ShipmentReturnApproval() {

    const [tableRecords, setTableRecords] = useState([]);
    const [shipmentDetails, setShipmentDetails] = useState(null);
    const { shipmentCode } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [actionType, setActionType] = useState('');
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const navigate = useNavigate();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [remark, setRemark] = useState('');
    const [error, setError] = useState('');
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const handleOpenModal = (action) => {
        setActionType(action);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setActionType('');
        setError('');
    };

    const handleConfirmAction = () => {
        if (actionType === 'reject' && remark.trim() === '') {
            setError('*');
            return; // Stop execution if remark is empty
        }
        setIsButtonDisabled(true);
        if (actionType === 'accept') {
            handleStatusUpdate(2);
            toast.success(`Shipment : ${shipmentCode} approved successfully.`, {
                onClose: () => navigate('/dashboard/shipmentapproval') // Step 2: Navigate on toast close
            });
        } else if (actionType === 'reject') {
            handleStatusUpdate(3, remark);
            toast.success(`Shipment : ${shipmentCode} rejected successfully.`, {
                onClose: () => navigate('/dashboard/shipmentapproval') // Step 2: Navigate on toast close
            });
        }
        handleCloseModal();
    };


    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const calculateBlockQty = () => {
        if (!shipmentDetails || !Array.isArray(shipmentDetails.tableData)) {
            return {};
        }

        const blockQtyMap = {};
        tableRecords.forEach((row) => {
            const { ProductCode, ReturnQuantity } = row;
            if (blockQtyMap[ProductCode]) {
                blockQtyMap[ProductCode] += ReturnQuantity;
            } else {
                blockQtyMap[ProductCode] = ReturnQuantity;
            }
        });

        return blockQtyMap;
    };


    const handleStatusUpdate = async (status, remark) => {
        const blockQtyMap = calculateBlockQty();

        if (!shipmentDetails) {
            console.error('Error: shipmentDetails is undefined');
            logAction('handleStatusUpdate(): Error - shipmentDetails or tableRecords is undefined', true);
            return;
        }

        try {
            const requests = tableRecords.map(async (row) => {
                const { ProductCode: productCode, ReturnQuantity, SHPD_ShipmentMID } = row;
                const blockQty = blockQtyMap[productCode] || 0;

                const response = await fetch(`${config.API_URL}/shipmentreturn/updateStatus`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        status,
                        shipmentCode,
                        blockQty,
                        productId: productCode,
                        scpid: selectedScpId,
                        ReturnQuantity,
                        SHPD_ShipmentMID,
                        SHPR_Comment: remark
                    }),
                });

                if (!response.ok) {
                    throw new Error('Failed to update status');
                }

                return response.json();
            });

            const results = await Promise.all(requests);
            console.log('Status updated:', results);
            logAction(`handleStatusUpdate(): Status updated to ${status} successfully`);
            // window.location.reload();
        } catch (error) {
            console.error('Error updating status:', error);
            logAction(`handleStatusUpdate(): Error - ${error.message}`, true);
        }
    };



    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch details from /shipmentreturnupdate/:shipmentCode
                const detailsResponse = await fetch(`${config.API_URL}/shipmentreturnview/${shipmentCode}`);
                if (!detailsResponse.ok) {
                    throw new Error('Failed to fetch shipment details');
                }
                const detailsData = await detailsResponse.json();
                setShipmentDetails(detailsData.shipmentDetails);
                logAction('Shipment details fetched successfully', false);

                // Ensure shipmentDetails exists and access SHPR_SCPCode
                if (detailsData.shipmentDetails) {
                    // Fetch table data from /shipmentreturn/tableData/:shipmentCode
                    const tableDataResponse = await fetch(`${config.API_URL}/shipmentreturn/tableData/${shipmentCode}`);
                    if (!tableDataResponse.ok) {
                        throw new Error('Failed to fetch table data');
                    }
                    const tableData = await tableDataResponse.json();

                    // Set default table records
                    const initialTableRecords = tableData.tableData.map(record => ({
                        SHPD_ShipmentMID: record.SHPD_ShipmentMID,
                        SCPCode: detailsData.shipmentDetails.SHPR_SCPCode,
                        SCPName: detailsData.shipmentDetails.SCPM_Name,
                        ShipmentCode: record.SHPDR_ShipmentCode,
                        ProductName: record.SHPDR_ProductName,
                        ProductCode: record.SHPDR_ProductCode,
                        ReceivedQuantity: record.SHPDR_ReceivedQty,
                        ReturnQuantity: record.SHPDR_ShipQty,
                    }));
                    setTableRecords(initialTableRecords);
                    logAction('Table data fetched and set successfully', false);
                } else {
                    throw new Error('shipmentDetails not found in response');
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
                logAction(`Error fetching initial data: ${error.message}`, true);
                // Handle error state if needed
            }
        };
        fetchInitialData();
    }, [shipmentCode]);

    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setRemark(value);
        if (error && value.trim() !== '') {
            setError('');
        }
    };
    return (

        <>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className="main_container">
                <h1 className="formHeading">Shipment Return</h1>
                <form autoComplete="off">
                    <div className="row mb-3">
                        <div className="col sm-6">
                            <label className="form-label">Shipment Code</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentCode}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="shipmentType">Shipment Type</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ShipmentType : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="returnReason">Return Reason </label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.ReturnReasonDescription : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="returnComment">Return Comment</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ReturnRemarks : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="shipmentDate">Shipment Date</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SHPR_ShipmentDate : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Logistic Party Name</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.LGCM_Name : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Vehicle Number</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.LGCVM_VehicleNumber : 'N/A'}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Shipment Status</label>
                            <input
                                type="text"
                                className="form-input"
                                StatusDescription
                                value={shipmentDetails ? shipmentDetails.StatusDescription : ''}
                                disabled
                            />
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="shipment">SCP Name</label>
                            <input
                                type="text"
                                className="form-input"
                                value={shipmentDetails ? shipmentDetails.SCPM_Name : ''}
                                disabled
                            />
                        </div>
                    </div>

                </form>
                {tableRecords.length > 0 && (
                    <div className="table_container mt-3">
                        <table className="tableClass">
                            <thead>
                                <tr>
                                    <th style={{ display: 'none' }}>Shipmnent MID</th>
                                    <th>Sr. No.</th>
                                    <th>SCP Name</th>
                                    <th>Shipment Code</th>
                                    <th>Product Name</th>
                                    <th>Product Code</th>
                                    <th>Received Quantity</th>
                                    <th>Return Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableRecords.map((record, index) => (
                                    <tr key={index}>
                                        <td style={{ display: 'none' }}>{record.SHPD_ShipmentMID}</td>
                                        <td>{index + 1}</td>
                                        <td>{record.SCPName}</td>
                                        <td>{record.ShipmentCode}</td>
                                        <td>{record.ProductName}</td>
                                        <td>{record.ProductCode}</td>
                                        <td>{record.ReceivedQuantity}</td>
                                        <td>{record.ReturnQuantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>

            <div className="button-container">
                <button onClick={() => handleOpenModal('accept')} className="save_btn" disabled={isButtonDisabled}>APPROVE</button>
                <button onClick={() => handleOpenModal('reject')} className="reset_btn" disabled={isButtonDisabled}>REJECT</button>

                <Link to={`/dashboard/shipmentapproval`} className="approvBack_btn" type="button">
                    BACK
                </Link>
            </div>


            {showModal && (
                <div className="popup_overlay">
                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to {actionType === 'accept' ? 'Approve' : 'Reject'} Shipment: {shipmentCode} ?</h4>
                        {actionType === "reject" && (
                            <div className="remark_container">
                                <span className="me-3 remark_label">
                                    Remark : {error && <span style={{ color: "red" }}>{error}</span>}
                                </span>
                                <textarea
                                    type="text"
                                    className="remark_text"
                                    value={remark}
                                    onChange={(e) => handleRemarkChange(e, setRemark, setError)}
                                    placeholder="Enter reject remarks"
                                    style={{
                                        border: "1px solid #ced4da",
                                        padding: "10px",
                                        fontSize: "16px",
                                        resize: "none",
                                        overflow: "auto",
                                        transition: "height 0.3s",
                                        borderRadius: "5px",
                                        outline: "none",
                                    }}
                                />
                            </div>
                        )}
                        <div className="popup_btn_container">
                            <button className="yes_btn " onClick={handleConfirmAction}>
                                YES
                            </button>
                            <button className="no_btn " onClick={handleCloseModal}>
                                NO
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>


    );
}

export default ShipmentReturnApproval;
